import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import {Promise} from "bluebird";
import _ from "lodash";
import {DATA_LIMIT} from "../constants/design-info.constant";

export {
    addDesignInfo,
    addSingleDesignInfo,
    updateSingleDesignInfo,
    getSingleDesignInfo,
    getAllDesignInfo,
    searchDesignInfo,
    searchDesignInfoWithSearchCriteria,
    prepareDesignInfoList
}

const collectionName = 'design-info';
const collectionReference = collection(fireStoreDB, collectionName);

const addDesignInfo = (designInfo) => {
    return Promise.map(designInfo, async designInfo => {
        await addSingleDesignInfo(designInfo);
    });
}

const addSingleDesignInfo = (designInfo) => {
    designInfo.createdAt = new Date();
    designInfo.updatedAt = designInfo.createdAt;
    return addDoc(collectionReference, designInfo);
}

const updateSingleDesignInfo = (designInfo) => {
    const documentReference = doc(fireStoreDB, collectionName, designInfo.id);
    designInfo.updatedAt = new Date();
    return setDoc(documentReference, designInfo, {merge: true});
}

const getSingleDesignInfo = async (designInfoId) => {
    const documentReference = doc(fireStoreDB, collectionName, designInfoId);
    const designInfoDoc = await getDoc(documentReference);
    return prepareSingleDesignInfo(designInfoDoc);
}

const getAllDesignInfo = async () => {
    let searchQuery = query(collectionReference);
    const designInfoResult = await getDocs(searchQuery);
    return prepareDesignInfoList(designInfoResult);
}

const searchDesignInfo = async (searchText, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(perPage));

    const designInfoResult = await getDocs(searchQuery);
    return prepareDesignInfoList(designInfoResult);
}

const searchDesignInfoWithSearchCriteria = async (searchCriteriaList, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    // console.log('searchDesignInfoWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    /*if (searchCriteriaList.length === 0) {
        searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
    }*/

    searchQuery = query(searchQuery, limit(perPage));

    const designInfoResult = await getDocs(searchQuery);
    return prepareDesignInfoList(designInfoResult);
}

const prepareDesignInfoList = (designInfoResult) => {
    const designInfoList = [];

    _.forEach(designInfoResult.docs, designInfoDoc => {
        designInfoList.push(prepareSingleDesignInfo(designInfoDoc));
    });

    return designInfoList;
}


const prepareSingleDesignInfo = (designInfoDoc) => {
    if (!designInfoDoc.exists()) {
        return null;
    }

    const designInfo = designInfoDoc.data();
    designInfo.id = designInfoDoc.id;
    return designInfo;
}
